// extracted by mini-css-extract-plugin
export default {"container":"newsletter-document_container__89P6s"};